import Minze, { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'
import { Locale } from '../../modules/locale'
import { Routing } from '../../modules/routing'

Locale.getInstance().registerKeySet('fr', 'profileSecurityModal', {
  title: 'Connexion et sécurité',
  previous: 'Précédent',
})

Locale.getInstance().registerKeySet('en', 'profileSecurityModal', {
  title: 'Sign in and security',
  previous: 'Previous',
})

export interface LvcProfileSecurityModal {}

export class LvcProfileSecurityModal extends MinzeElement {
  modalId = MODALS.PROFILE_SECURITY_MODAL

  onReady(): void | Promise<void> {}

  goBack = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profile)
  }

  html = () => `
    <lvc-modal is-fullscreen-modal-scrollable="true" modal-id="${this.modalId}" left-title="true" show-when-logged="true" narrow="true" modal-title="${Locale.getKey('profileSecurityModal.title')}">
      <div slot="lvc-modal-content">
        <lvc-profile-security-modal-content></lvc-profile-security-modal-content>
      </div>
    </lvc-modal>
  `

  css = () => `
    :host {

    }
    [name="link-back"] {
      cursor: pointer;
    }


  `

  eventListeners: EventListeners = [['[name="link-back"]', 'click', this.goBack]]
}
